import "./style.scss";
import "styles/braintree.scss";

import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";

import config from "config";
import PrimaryBlackButton from "gyg_common/components/Buttons/PrimaryBlackButton";
import { OrderResponse } from "gyg_common/services/api/order/model";
import OrderSetupHeaderContainer from "views/containers/OrderSetupHeader/OrderSetupHeaderContainer";
import HeaderContainer from "views/containers/shared/Header/HeaderContainer";

import PaymentReceipt from "./PaymentReceipt";

export interface PaymentProps {
  order: OrderResponse | null;
  fullLoyaltyPayment: boolean;
  isDisabled: boolean;
  onGoogleReCAPTCHA: (value: string | null) => void;
  onGoogleReCAPTCHAExpired?: () => void;
  onPayClick: () => void;
  isLoading: boolean;
  deliveryFee?: number;
}

export const Payment: React.FC<PaymentProps> = ({
  fullLoyaltyPayment,
  isDisabled,
  order,
  onGoogleReCAPTCHA,
  onGoogleReCAPTCHAExpired,
  onPayClick,
  isLoading,
  deliveryFee,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <HeaderContainer
        viewCart={true}
        pageTitle={t("CheckoutPayment:paymentTitle")}
        bottomComponentNotScrollable={<OrderSetupHeaderContainer disable />}
      />
      <div className='main-wrapper'>
        {!fullLoyaltyPayment && (
          <div className='main-wrapper__col'>
            <div id='dropin-container'></div>
          </div>
        )}

        <div
          className={`main-wrapper__col ${
            fullLoyaltyPayment ? `main-wrapper__col--single` : ""
          }`}>
          <PaymentReceipt order={order} deliveryFee={deliveryFee} />
          {config.googleRecaptchaSiteKey && (
            <div className='recaptcha-button'>
              <ReCAPTCHA
                sitekey={config.googleRecaptchaSiteKey}
                onChange={onGoogleReCAPTCHA}
                onExpired={onGoogleReCAPTCHAExpired}
              />
            </div>
          )}

          <div className='pay-button'>
            <PrimaryBlackButton
              testId={t("CheckoutPayment:payNowButton")}
              buttonName={t("CheckoutPayment:payNowButton")}
              onClick={onPayClick}
              loading={isLoading}
              disable={isDisabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
